export type QuestionId =
  | 'age'
  | 'skinType'
  | 'concern'
  | 'morning'
  | 'products'
  | 'spf'
  | 'goal'
  | 'consent'

export type Question = {
  id: QuestionId
  title: string
  note?: string
  options: { value: string; label: string }[]
}

export const questions: Question[] = [
  {
    id: 'age',
    title: '¿Qué edad tenés?',
    note: 'La piel cambia sus necesidades con el tiempo.',
    options: [
      { value: 'u30', label: 'Menos de 30' },
      { value: '30s', label: '30-39' },
      { value: '40s', label: '40-49' },
      { value: '50+', label: '50+' },
    ],
  },
  {
    id: 'skinType',
    title: '¿Cómo describirías tu piel?',
    options: [
      { value: 'seca', label: 'Seca' },
      { value: 'mixta', label: 'Mixta' },
      { value: 'grasa', label: 'Grasa' },
      { value: 'sensible', label: 'Sensible' },
      { value: 'nose', label: 'No estoy segura' },
    ],
  },
  {
    id: 'concern',
    title: '¿Qué es lo que más te preocupa?',
    options: [
      { value: 'lineas', label: 'Líneas de expresión' },
      { value: 'manchas', label: 'Manchas' },
      { value: 'acne', label: 'Acné' },
      { value: 'luminosidad', label: 'Falta de luminosidad' },
      { value: 'rojez', label: 'Enrojecimiento' },
      { value: 'deshidratacion', label: 'Deshidratación' },
    ],
  },
  {
    id: 'morning',
    title: '¿Cómo se siente tu piel al despertarte?',
    options: [
      { value: 'tirante', label: 'Tirante' },
      { value: 'comoda', label: 'Cómoda' },
      { value: 'brillante', label: 'Brillante' },
      { value: 'variable', label: 'Variable' },
    ],
  },
  {
    id: 'products',
    title: '¿Cuántos productos usás actualmente?',
    options: [
      { value: 'ninguno', label: 'Ninguno' },
      { value: 'limpiador', label: 'Solo limpiador' },
      { value: 'dostres', label: 'Dos o tres' },
      { value: 'rutina', label: 'Rutina completa' },
    ],
  },
  {
    id: 'spf',
    title: '¿Con qué frecuencia usás protector solar?',
    options: [
      { value: 'diario', label: 'Todos los días' },
      { value: 'aveces', label: 'Algunas veces' },
      { value: 'nunca', label: 'Nunca' },
    ],
  },
  {
    id: 'goal',
    title: '¿Cuál es tu objetivo principal?',
    options: [
      { value: 'prevenir', label: 'Prevenir envejecimiento' },
      { value: 'hidratacion', label: 'Mejorar hidratación' },
      { value: 'luminosidad', label: 'Recuperar luminosidad' },
      { value: 'calmar', label: 'Calmar la piel' },
      { value: 'tono', label: 'Unificar tono' },
    ],
  },
  {
    id: 'consent',
    title: '¿Te gustaría recibir una recomendación personalizada?',
    note: 'Sin compromiso. Solo para orientarte mejor.',
    options: [
      { value: 'si', label: 'Sí' },
      { value: 'claro', label: 'Claro' },
    ],
  },
]
